import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-advert-bar',
  templateUrl: './advert-bar.component.html',
  styleUrls: ['./advert-bar.component.scss']
})
export class AdvertBarComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
